module.exports = "<pplus-meter-cosphi></pplus-meter-cosphi>\r\n"